<template>
  <div class="font-adjust-box d-flex align-item-center">
    <v-btn
      tag="button"
      class-name="font-add-btn"
      @btnClick="isShowMode = !isShowMode"
    >
      <v-icon>format_size</v-icon>
    </v-btn>
    <transition name="fade">
      <div class="font-adjust-group" v-show="isShowMode">
        <div class="font-circle d-flex justify-content-between">
          <v-btn class="font-add" @btnClick="on_font_size_change(true)"
            ><svg
              id="Text_-24px"
              data-name="Text +-24px"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                id="路径_7551"
                data-name="路径 7551"
                d="M0,0H24V24H0Z"
                fill="none"
              />
              <path
                id="路径_7552"
                data-name="路径 7552"
                d="M5,5.318A1.316,1.316,0,0,0,6.318,6.636H9.832v9.225a1.318,1.318,0,0,0,2.636,0V6.636h3.514a1.318,1.318,0,1,0,0-2.636H6.318A1.316,1.316,0,0,0,5,5.318Z"
                transform="translate(-2 1)"
              />
              <path
                id="联合_476"
                data-name="联合 476"
                d="M1610.934,21025.578v-1.395h-1.667a.929.929,0,1,1,0-1.857h1.667v-1.4a.929.929,0,0,1,1.858,0v1.4h1.514a.929.929,0,1,1,0,1.857h-1.514v1.395a.929.929,0,0,1-1.858,0Z"
                transform="translate(-1593.336 -21011.203)"
              /></svg
          ></v-btn>
          <v-btn class="font-cut" @btnClick="on_font_size_change"
            ><svg
              id="Text_--24px"
              data-name="Text --24px"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                id="路径_7551"
                data-name="路径 7551"
                d="M0,0H24V24H0Z"
                fill="none"
              />
              <path
                id="路径_7552"
                data-name="路径 7552"
                d="M5,5.318A1.316,1.316,0,0,0,6.318,6.636H9.832v9.225a1.318,1.318,0,0,0,2.636,0V6.636h3.514a1.318,1.318,0,1,0,0-2.636H6.318A1.316,1.316,0,0,0,5,5.318Z"
                transform="translate(-2 1)"
              />
              <rect
                id="矩形_4570"
                data-name="矩形 4570"
                width="6.845"
                height="2.028"
                rx="1"
                transform="translate(15.155 10.999)"
              />
            </svg>
          </v-btn>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "font-adjust",
  props: {},
  data() {
    return {
      isShowMode: false,
    };
  },
  computed: {
    ...mapState("global", ["changeFontSize"]),
  },
  created() {
    document.onclick = () => {
      this.isShowMode = false;
    };

    this.$P.isIE11 &&
      $("head").append(`<style id="font-size" type="text/css" />`);
  },

  methods: {
    ...mapMutations("global", ["updateFontSize"]),

    /**
     * 获取当前文字大小
     */
    get_current_font_size() {
      let fontBox = document.querySelector(".set-font-size");

      let font = !this.$P.isIE11
        ? window.getComputedStyle(fontBox).getPropertyValue("--font-size")
        : window.getComputedStyle(fontBox).fontSize;

      return parseInt(font);
    },

    /**
     * 字体放大缩小效果
     */
    on_font_size_change(isAdd) {
      let fontChange = isAdd
        ? this.get_current_font_size() + 2
        : this.get_current_font_size() - 2;
      fontChange = Math.max(Math.min(26, fontChange), 14);
      $(".set-font-size").css("--font-size", `${fontChange}px`);
      this.updateFontSize(fontChange);

      this.$P.isIE11 && this.compatible_ie11(fontChange);
    },
    /**
     * 兼容 IE 字体放大缩小
     */
    compatible_ie11(fontChange) {
      let style = `
        .set-font-size h2 {
          font-size:${fontChange + 4}px
        }
        .set-font-size, 
        .set-font-size p, 
        .set-font-size .gold {
          font-size:${fontChange}px !important;
        }
        .set-font-size .bigMarginBot,
        .set-font-size .from {
          font-size:${fontChange - 2}px
        }
        .set-font-size .human-word {
          font-size:${fontChange - 1}px
        }`;

      $("#font-size").html(style);
    },
  },
  destroyed() {
    $("#font-size").remove();
  },
};
</script>

<style lang="scss">
.font-adjust-group {
  position: absolute;
  top: 54px;
  right: 60px;

  &::before {
    content: "";
    display: block;
    width: 12px;
    height: 12px;
    position: absolute;
    top: -6px;
    right: 20px;
    z-index: 0;
    box-shadow: 0px 0px 5px 0px rgba($color-black, 0.16);
    transform: rotate(45deg);
    background-color: $color-white;
  }

  .font-circle {
    position: relative;
    z-index: 2;
    width: 120px;
    height: 50px;
    background-color: $color-white;
    padding: 7px 18px;
    box-shadow: 0 3px 6px rgba($color-black, 0.16);
    border-radius: 6px;

    .v-btn {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;

      &:hover {
        svg {
          fill: #003893;
        }
      }
      &:active {
        background-color: rgba(#003893, 0.05);
      }
    }
  }
}
</style>
